import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Checkbox } from '@mantine/core';

import { selectShowLiabilities, selectShowSHM, setShowLiabilities, setShowSHM } from '../../../store/slices/antibodyAnalysis.slice';
import type { AppDispatch } from '../../../store/store';

const s = {
  group: 'flex items-center gap-3',
  label: 'text-sm font-medium text-[#3d3d3d]',
} as const;

/**
 * AnnotateControls — the "Annotate: Liabilities / SHM" checkboxes.
 *
 * Extracted from ControlBar so Hit selection and Export summary render the same control
 * from one place. Like SequenceControlsBar it takes no props and reads straight from
 * `antibodyAnalysis.slice`, so the two pages share a single annotation state: turning
 * SHM off on one page turns it off on the other.
 */
export function AnnotateControls() {
  const dispatch = useDispatch<AppDispatch>();
  const showLiabilities = useSelector(selectShowLiabilities);
  const showSHM = useSelector(selectShowSHM);

  return (
    <div className={s.group}>
      <span className={s.label}>Annotate</span>
      <Checkbox label="Liabilities" checked={showLiabilities} onChange={(event) => dispatch(setShowLiabilities(event.currentTarget.checked))} size="xs" />
      <Checkbox label="SHM" checked={showSHM} onChange={(event) => dispatch(setShowSHM(event.currentTarget.checked))} size="xs" />
    </div>
  );
}
